import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

const ResourceGroupPageLink = ({ link }) => (
	<Typography
		key={link.id}
		sx={{
			mt: { xs: 2, md: 3 },
		}}
		variant='body1'
	>
		{link.type === 'page' ? (
			<Typography
				color='secondary'
				component={RouterLink}
				style={{ textDecoration: 'none' }}
				to={link.url}
			>
				{link.text}
			</Typography>
		) : (
			<Link
				style={{ textDecoration: 'none' }}
				href={link.url}
				target='_blank'
				rel='noreferrer'
				color='secondary'
			>
				<PictureAsPdfOutlinedIcon
					color='secondary'
					fontSize='1rem'
					sx={{
						mr: 1,
					}}
				/>
				{link.text}
			</Link>
		)}
	</Typography>
);

ResourceGroupPageLink.propTypes = {
	link: PropTypes.object.isRequired,
};

export default ResourceGroupPageLink;
